import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import axios from 'axios';

const styles = {
  root: {
    width: "100vw",
    // minWidth: '150px',
    // height: '500px',
    // minHeight: '350px',
    align: "center",
    //overflowX: 'auto',
    //display: 'column',
    alignItem: "center",
    // margin: '0 Auto',
  },
  formControl: {
    // margin: theme.spacing.unit * 3,
  },
  group: {},
  radio: {
    "&$checked": {
      color: "#B71C1C",
    },
  },
  checked: {},
  progress: {
    /*display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItem: 'center',*/
    flexDirection: "column",
    // margin: theme.spacing.unit * 3,
  },
  button: {
    display: "flex",
    justifyContent: "center",
    // margin: '0 Auto',
  },
  InputLabel: {
    fontSize: "14px",
  },
  rightInput: {
    marginLeft: "50px",
  },
  country: {
    marginTop: "15px",
    marginBottom: "10px",
  },
  hkidPassport: {
    marginTop: "15px",
    marginBottom: "10px",
  },
};

class SMSStatus extends Component {
  state = {
    Ccreated:false,
    Rcreated:false
  };

  handleChange = (userType) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/createSMSSentPDF`
    this.setState({
      Ccreated: false,
      Rcreated: false
    })
    const data = {
      caseId: parseInt(this.props.caseData.caseId),
      userType: userType
    }
    console.log(data)
    axios.post(url, {
      ...data
    })
    .then((response) => {
      console.log('created ##')
      if (userType == 'claimant'){
        this.setState({
          Ccreated: true
        })
      }
      else{
        this.setState({
          Rcreated: true
        })
      }

    })
  }

  render() {
    const { classes } = this.props;

    return (
      <div style={{ marginLeft:'20px' }}>
        <br></br>
        <b style={{marginLeft:'15px'}}>{this.context.t("SMS")}</b><br></br>
        <Button
            variant="contained"
            type="submit"
            color="primary"
            disabled={this.props.submitInProgress}
            className={classes.bInput}
            onClick={()=> {this.handleChange('claimant')}}
            style={{
              fontSize: "14px",
              marginBottom: "15px",
              textTransform: 'capitalize',
              marginLeft:'15px'
            }}
          >{this.context.t("Download Claimant SMS record")}</Button> &nbsp;&nbsp;&nbsp;
          { this.state.Ccreated && <a style={{color:'red'}} target="_blank" href={`${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.caseData.caseId + '_' + 'SMSStatus'}`}>{this.context.t("Download PDF")}</a>}<br></br>
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disabled={this.props.submitInProgress}
            className={classes.bInput}
            onClick={()=> {this.handleChange('respondent')}}
            style={{
              fontSize: "14px",
              marginBottom: "15px",
              textTransform: 'capitalize',
              marginLeft:'15px'
            }}
          >{this.context.t("Download Respondent SMS record")}</Button> &nbsp;&nbsp;&nbsp;
          { this.state.Rcreated && <a style={{color:'red'}} target="_blank" href={`${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.caseData.caseId + '_' + 'SMSStatus'}`}>{this.context.t("Download PDF")}</a>}<br></br>
        {/* <Card className={classes.card}>
          <CardContent>
          {this.props.caseData.sms !== undefined && this.props.caseData.sms.map((sms, index) => (
              <div>
                <label style={{ fontSize: "12px" }}>{this.context.t("tele")} : {sms.to}</label><br></br>
                <label style={{ fontSize: "12px" }}>{this.context.t("Date")} : {sms.dateCreated}</label><br></br>
                <label style={{ fontSize: "12px" }}>{this.context.t("Status")} : {sms.status}</label><br></br>
                <label style={{ fontSize: "12px" }}>{(''+sms.body).replace('\n\n',' ')}</label><br></br>
              </div>
            ))}
          </CardContent>
        </Card> */}
      </div>
    );
  }
}

// export default withStyles(styles)(ArbitratorAcceptRejectBox);
const mapStateToProps = (state) => {
  return {
    caseId: state.caseInfo.caseId,
    caseData: state.caseInfo.caseData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    AdminAcceptReject: (caseId, status) =>
      dispatch(actions.AdminAcceptReject(caseId, status)),
  };
};

SMSStatus.contextTypes = {
  t: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withRouter(SMSStatus)));
